import { type TableCell } from '~/shared/ui/Table';

export enum OrderTableColumn {
    ID = 'ID',
    CREATED_AT = 'Дата создания',
    EXPIRED_AT = 'Дата истечения',
    REQUISITE = 'Реквизиты',
    AMOUNT = 'Сумма',
    CURRENCY = 'Валюта',
    RATE = 'Курс',
    PRIORITY = 'Приоритет',
    STATUS = 'Статус',
}

export const orderTableHeaders: TableCell[] = [
    {
        key: OrderTableColumn.ID,
        content: OrderTableColumn.ID,
    },
    {
        key: OrderTableColumn.CREATED_AT,
        content: OrderTableColumn.CREATED_AT,
    },
    {
        key: OrderTableColumn.EXPIRED_AT,
        content: OrderTableColumn.EXPIRED_AT,
    },
    {
        key: OrderTableColumn.REQUISITE,
        content: OrderTableColumn.REQUISITE,
    },
    {
        key: OrderTableColumn.AMOUNT,
        content: OrderTableColumn.AMOUNT,
    },
    {
        key: OrderTableColumn.CURRENCY,
        content: OrderTableColumn.CURRENCY,
    },
    {
        key: OrderTableColumn.RATE,
        content: OrderTableColumn.RATE,
    },
    {
        key: OrderTableColumn.PRIORITY,
        content: OrderTableColumn.PRIORITY,
    },
    {
        key: OrderTableColumn.STATUS,
        content: OrderTableColumn.STATUS,
    },
];
